import * as fromCookiesAllowed from './cookies-allowed';
import { ActionReducerMap } from '@ngrx/store';

export interface CookiesState {
  cookiesAllowed: fromCookiesAllowed.CookiesAllowedState;
}

export const reducers: ActionReducerMap<CookiesState> = {
  cookiesAllowed: fromCookiesAllowed.reducer,
};

export const effects = [fromCookiesAllowed.CookiesAllowedEffects];
